/**
 * 与 vue.config.js publicPath / Vue CLI 的 process.env.BASE_URL 一致（生产多为 /xcx/）。
 * 用于 history API、window.location 等「浏览器真实路径」，避免写成 /home、/login 导致脱离子目录。
 */

export function getRouterBaseNoSlash() {
  const b = process.env.BASE_URL || '/'
  const trimmed = b.endsWith('/') ? b.slice(0, -1) : b
  return trimmed
}

/** 浏览器地址栏应使用的路径，如 /xcx/home；开发 base 为 / 时为 /home */
export function appFullPath(routePath) {
  const p = routePath.startsWith('/') ? routePath : `/${routePath}`
  const base = getRouterBaseNoSlash()
  if (!base) {
    return p
  }
  return `${base}${p}`
}
